import GeneralInformation from './GeneralInformation'

export default GeneralInformation
